window.MOCK_SERVER = 'https://f975644d-73db-4c0b-920c-7c793fa7e8db.mock.pstmn.io';

const ROUTERS_MAP = ['cart'];

function isSpecialRoute(route) {
  return ROUTERS_MAP.find(el => el === route);
}

document.addEventListener('DOMContentLoaded', () => {
  const CART_UPDATE_SUMMARY_URI = '/cart/update-summary';
  const checkSpecialUrl = window.location.pathname.split('/').find(route => route === isSpecialRoute(route));

  document.updateCartIcon = (count) => {
    if (!checkSpecialUrl) {
      const parent = $('.header-account-link');
      if (parent !== null) {
        if (count === 0) {
          parent.addClass('disabled');
        } else {
          parent.removeClass('disabled');
        }
      }
      $('.header-account-badge').text(count);
    }
  };

  document.updateCartSummary = () => {
    window.promiseQueue.add('cart-summary', () => {
      window.axios
        .get(CART_UPDATE_SUMMARY_URI)
        .then((response) => {
          response.data = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
          $('#total-count').html(response.data?.totalCount);
          $('#total-sum').html(response.data?.totalSum);
          $('#total-price').html(response.data?.totalPrice);
        })
        .catch((error) => {
          document.modalMessageErrorShow();
          // eslint-disable-next-line no-console
          console.warn(error);
        });
    });
  };

  document.clearCart = () => {
    document.updateCartIcon(0);
    document.updateCartSummary();
    document.querySelectorAll('.order-list .order-item').forEach((item) => {
      item.remove();
    });
  };
});
